import React, { useState, useContext, useEffect } from "react";
import { AccountContext } from "../../context/AccountContext";
import { Link as ReachLink, useNavigate } from "react-router-dom";
import {
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Spinner,
  Box,
  Heading,
  Text,
  Link,
  FormControl,
  Flex,
  Spacer,
  useDisclosure,
  Modal,
} from "@chakra-ui/react";
import { EmailIcon, LockIcon, ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { NewPasswordForm } from "./NewPasswordForm";
import { OverlayOne } from "../../util/utility";

function SignIn() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [overlay, setOverlay] = React.useState(<OverlayOne />);
  const navigate = useNavigate();
  const { authenticate, getSession, newPasswordChallenge } = useContext(AccountContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [user, setUser] = useState(null)


  useEffect(() => {
    if (errorText) {
      setErrorText("");
    }
  }, [email, password]);

  useEffect(() => {
    isSessionActive();
  }, []);

  const isSessionActive = () => {
    getSession()
      .then((session) => {
        console.log(session);
        navigate("/home");
      })
      .catch((e) => {
        console.log(e);
        navigate("/");
      });
  };

  const handleShowPwd = () => setShowPwd(!showPwd);

  const onSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    authenticate(email, password)
      .then((data) => {
        setIsLoading(false);
        console.log("Loggen In", data);
        if (data?.NEW_PASSWORD_REQUIRED) {
          setUser(data.user)
          setOverlay(<OverlayOne />);
          onOpen()
        } else {
          navigate("/home");
        }
      })
      .catch((err) => {
        console.error(err);
        setErrorText(err.message);
        setIsLoading(false);
      });
  };

  return (
    <>
      <Box>
        <Heading mb={4}>Welcome</Heading>

        <Text fontSize="xl" mt={6} mb={2}>
          Member Login
        </Text>

        <form onSubmit={onSubmit}>
          <FormControl>
            <InputGroup mt={2} mb={2}>
              <InputLeftElement
                pointerEvents="none"
                children={<EmailIcon />}
                color="gray"
              />
              <Input
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </InputGroup>
          </FormControl>

          <FormControl>
            <InputGroup mt={2} mb={2}>
              <InputLeftElement
                pointerEvents="none"
                children={<LockIcon />}
                color="gray"
              />
              <Input
                type={showPwd ? "text" : "password"}
                placeholder="Enter Password"
                autoComplete="true"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
              <InputRightElement
                children={
                  showPwd ? (
                    <ViewIcon color="gray" onClick={handleShowPwd} />
                  ) : (
                    <ViewOffIcon color="gray" onClick={handleShowPwd} />
                  )
                }
              />
            </InputGroup>
          </FormControl>

          <Flex>
            <Button
              mt={2}
              mb={2}
              type="submit"
              size="sm"
              colorScheme="blue"
              disabled={isLoading || email.length === 0 || password.length === 0}
            >
              {isLoading && <Spinner size="sm" mr={2} />}
              Sign In
            </Button>
            <Spacer />

            <Link as={ReachLink} to="/forgot-pwd" mt={2}>
              Forgot Password?
            </Link>
          </Flex>

          <Text fontSize="xs" color="red">
            {errorText}
          </Text>
        </form>

        <Text mt={6}>
          Want to Register?
          <br />
          <Link as={ReachLink} to="/sign-up">
            Sign Up
          </Link>
        </Text>
      </Box>
      <Modal
        closeOnOverlayClick={false}
        isCentered
        onOpen={onOpen}
        isOpen={isOpen}
        onClose={onClose}
      >
        {overlay}
        <NewPasswordForm
          onClose={onClose}
          user={user}
          newPasswordChallenge={newPasswordChallenge} />
      </Modal>
    </>
  );
}

export default SignIn;
